<div (click)="redirectToViessmannHomeWithInvitationLink()" class="banner">
  <div class="column1">
    <div class="headline">{{ 'APPOI.VIESSMANN_HOME_BANNER.HEADLINE' | translate }}</div>
    <div class="divider"></div>
    <div class="description">{{ 'APPOI.VIESSMANN_HOME_BANNER.TEXT' | translate }}</div>
  </div>
  <div class="column2">
    <div class="button">
      <button class="d-flex d-sm-none vi-button vi-button-xs" color="primary"
              mat-flat-button
      >{{ 'APPOI.BUTTON.REGISTER_NOW' | translate }}
      </button>
      <button class="d-none d-sm-flex vi-button" color="primary"
              mat-flat-button
      >{{ 'APPOI.BUTTON.REGISTER_NOW' | translate }}
      </button>
    </div>
  </div>
</div>
